angular.module('calendarEventRules.constants', [])
    .constant('calendarEventLocationOption', {
        UseGroup: 1,
        SpecifyLocation: 2,
        Other: 3,
    });